export interface ProductsConfig {
  G2C_URL: string
  G2ARS_URL: string
  G2ASEEIT_URL: string
  G2ASD_URL: string
  G2M_URL: string
  G2W_URL: string
  G2T_URL: string
  OPENVOICE_URL: string
}

const productsConfig: { [key in 'local' | 'development' | 'staging' | 'production']: ProductsConfig } = {
  local: {
    G2C_URL: 'https://my.dev.jive.com/',
    G2ARS_URL: 'https://i1app.gotoassist.com/?product=g2ap',
    G2ASEEIT_URL: 'https://seeitaws.col.test.expertcity.com',
    G2ASD_URL: 'https://i1desk.gotoassist.com',
    G2M_URL: 'https://globaled1.g2m.test.expertcity.com',
    G2W_URL: 'https://globaled1.g2w.test.expertcity.com',
    G2T_URL: 'https://globaled1.g2t.test.expertcity.com',
    OPENVOICE_URL: 'https://openvoiceportaled1svc1.qai.expertcity.com:8080',
  },
  development: {
    G2C_URL: 'https://my.dev.jive.com/',
    G2ARS_URL: 'https://i1app.gotoassist.com/?product=g2ap',
    G2ASEEIT_URL: 'https://seeitaws.col.test.expertcity.com',
    G2ASD_URL: 'https://i1desk.gotoassist.com',
    G2M_URL: 'https://globaled1.g2m.test.expertcity.com',
    G2W_URL: 'https://globaled1.g2w.test.expertcity.com',
    G2T_URL: 'https://globaled1.g2t.test.expertcity.com',
    OPENVOICE_URL: 'https://openvoiceportaled1svc1.qai.expertcity.com:8080',
  },
  staging: {
    G2C_URL: 'https://my.staging.jive.com/',
    G2ARS_URL: 'https://stageapp.gotoassist.com/?product=g2ap',
    G2ASEEIT_URL: 'https://stageseeit.gotoassist.com',
    G2ASD_URL: 'https://stagedesk.gotoassist.com',
    G2M_URL: 'https://globalstage.gotomeeting.com',
    G2W_URL: 'https://globalstage.gotowebinar.com',
    G2T_URL: 'https://globalstage.gototraining.com',
    OPENVOICE_URL: 'https://globalstage.openvoice.com',
  },
  production: {
    G2C_URL: 'https://my.jive.com/',
    G2ARS_URL: 'https://app.gotoassist.com/?product=g2ap',
    G2ASEEIT_URL: 'https://seeit.gotoassist.com',
    G2ASD_URL: 'https://desk.gotoassist.com',
    G2M_URL: 'https://global.gotomeeting.com/',
    G2W_URL: 'https://global.gotowebinar.com/',
    G2T_URL: 'https://global.gototraining.com',
    OPENVOICE_URL: 'https://global.openvoice.com',
  },
}

export default productsConfig
